import React from 'react'
import { Link } from 'react-router-dom'
import { BookOpen, Pencil, Plus, ArrowLeft } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { useSidebar } from '@/components/ui/sidebar'
import SelectedTutor from './SelectedTutor'
import NoTutorSelectedNotification from './NoTutorSelectedNotification'
import FeedbackTypeSelector from './FeedbackTypeSelector'

const ContentSidebar = ({
  name,
  tutor,
  prompt,
  seriesId,
  setIsTutorSelectionModalOpen,
  setIsLessonPromptModalOpen,
  handleAddBlock,
  sortedBlocks,
  BlockListComponent,
  feedbackType,
  onFeedbackTypeChange,
  isUpdatingFeedbackType
}) => {
  const { setOpen } = useSidebar()

  return (
    <div className='flex flex-col h-full relative'>
      <div className="sticky top-0 left-0 bg-background pt-5 z-50">
        <Link to={`/educators/courses/${seriesId}`} className="w-fit mb-4 block">
          <Button
            variant="outline"
            size="sm"
            className='w-full flex items-center'
            onClick={() => setOpen(true)}
            as="div"
          >
            <ArrowLeft className='size-5 mr-2' />
            Back to pathway
          </Button>
        </Link>

        <div className='flex flex-row items-start mb-4'>
          <BookOpen className='size-5 mt-1' />
          <h1 className='text-lg font-semibold ml-3 leading-tight'>{name}</h1>
        </div>
      </div>

      {/* Main scroll content area */}
      <div className="flex-1 min-h-0 overflow-y-auto">
        <h2 className='text-md font-semibold mb-2'>Tutor</h2>
        <Choose>
          <When condition={tutor}>
            <SelectedTutor
              name={tutor.name}
              imageUrl={tutor.image?.url}
              description={tutor.description}
              summary={tutor.summary}
              openModal={() => setIsTutorSelectionModalOpen(true)}
            />
          </When>

          <When condition={prompt}>
            <div className='flex items-center leading-none'>
              <button
                onClick={() => setIsLessonPromptModalOpen(true)}
                className='flex group items-center text-sm text-blue-600 hover:underline'
              >
                Edit lesson prompt
                <span className='ml-2 group-hover:bg-gray-200 rounded-full p-1'>
                  <Pencil className='size-5' />
                </span>
              </button>
            </div>
          </When>

          <Otherwise>
            <NoTutorSelectedNotification
              openModal={() => setIsTutorSelectionModalOpen(true)}
              lessonName={name}
            />
          </Otherwise>
        </Choose>

        <div className="mt-4">
          <h2 className='text-md font-semibold mb-2'>Feedback Type</h2>
          <FeedbackTypeSelector
            value={feedbackType}
            onValueChange={onFeedbackTypeChange}
            disabled={isUpdatingFeedbackType}
            isLoading={isUpdatingFeedbackType}
          />
        </div>

        <h2 className='text-md font-semibold mt-4 mb-2'>Outline</h2>

        {/* Render the passed BlockList component */}
        <BlockListComponent />

        <Button
          variant="outline"
          onClick={() => handleAddBlock(sortedBlocks.length)}
          className='mt-2 mb-8 border-dashed text-gray-500'
        >
          <Plus className='size-5' />
          Add block
        </Button>
      </div>
    </div>
  )
}

export default ContentSidebar 
